import { render } from "./DashboardContent.vue?vue&type=template&id=22fc51a8"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__